import { createFileRoute, redirect } from '@tanstack/react-router'

// Variante anglaise historique — redirige directement, sans passer par
// `/informations-personnelles` qui redirige elle aussi.
export const Route = createFileRoute('/_authenticated/_layout/personal-informations')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/mon-profil' })
  },
})
